<p-sidebar [(visible)]="showPopup"
           [position]="'right'"
           [modal]="false"
           (onHide)="handleSideBarHide()"
           [style]="{width:'620px'}">
    <ng-template pTemplate="header">
        <div style="font-weight:bold; font-size: 18px; margin-left: 10px; letter-spacing: -0.43px; color: #333333; opacity: 0.5;">Edit Service</div>
    </ng-template>
    <div>
        <img *ngIf="serviceType === 1" src="/XpressApp/assets/images/service-moto-edit.png" />
        <img *ngIf="serviceType === 2" src="/XpressApp/assets/images/service-moto-edit.png" />
        <img *ngIf="serviceType === 3" src="/XpressApp/assets/images/service-moto-edit.png" />
    </div>
    <div style="position: fixed; right: 20px; bottom: 20px;">
        <button pButton pRipple type="button" label="Save" style="margin-right: 10px" (click)="handleSideBarHide()"></button>
        <button pButton pRipple type="button" label="Cancel" class="p-button-outlined p-button-info" (click)="handleSideBarHide()"></button>

    </div>
</p-sidebar>